module.exports = __webpack_public_path__ + "img/error.8e4e8ffe.png";